// PostHog + GA4 + FB Pixel — Halal LP Full Funnel Tracking v4
// Fixes tier attribution for CTA events by inferring from variant, DOM context, and CTA copy.

/* eslint-disable no-var */
!(function (t, e) {
  var o, n, p, r;
  if (!e.__SV) {
    window.posthog = e;
    e._i = [];
    e.init = function (i, s, a) {
      function g(t2, e2) {
        var o2 = e2.split(".");
        if (o2.length === 2) {
          t2 = t2[o2[0]];
          e2 = o2[1];
        }
        t2[e2] = function () {
          t2.push([e2].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }

      p = t.createElement("script");
      p.type = "text/javascript";
      p.crossOrigin = "anonymous";
      p.async = true;
      p.src =
        s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js";
      r = t.getElementsByTagName("script")[0];
      r.parentNode.insertBefore(p, r);

      var u = e;
      if (a !== void 0) {
        u = e[a] = [];
      } else {
        a = "posthog";
      }

      u.people = u.people || [];
      u.toString = function (t2) {
        var e2 = "posthog";
        if (a !== "posthog") e2 += "." + a;
        if (!t2) e2 += " (stub)";
        return e2;
      };
      u.people.toString = function () {
        return u.toString(1) + ".people (stub)";
      };

      o =
        "init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(
          " "
        );
      for (n = 0; n < o.length; n += 1) g(u, o[n]);
      e._i.push([i, s, a]);
    };
    e.__SV = 1;
  }
})(document, window.posthog || []);

function getTrafficProps() {
  try {
    return JSON.parse(sessionStorage.getItem("_ph_traffic") || "{}");
  } catch (_e) {
    return {};
  }
}

function inferTier(link) {
  if (!link) return "unknown";
  var href = link.getAttribute("href") || "";
  var linkText = (link.textContent || "").toLowerCase();

  try {
    var url = new URL(href, window.location.origin);
    var variant = url.searchParams.get("variant");
    if (variant === "51498835149016") return "select";
    if (variant === "51498835181784") return "premium";
  } catch (_e) {
    // ignore invalid URL and continue fallback checks
  }

  var tierContainer = link.closest(".tier-luxury");
  if (tierContainer) {
    if (tierContainer.classList.contains("select")) return "select";
    if (tierContainer.classList.contains("premium")) return "premium";
  }

  if (linkText.indexOf("select") > -1 || href.indexOf("51498835149016") > -1) return "select";
  if (linkText.indexOf("premium") > -1 || href.indexOf("51498835181784") > -1) return "premium";

  return "unknown";
}

function inferCtaLocation(link) {
  if (!link) return "unknown";
  if (link.classList.contains("sticky-cta-btn") || link.closest("#sticky-cta-mobile")) return "sticky_mobile";
  if (link.closest("#stickyCta")) return "sticky_bar";
  if (link.closest(".final-cta")) return "final_cta";
  if (link.closest(".hero")) return "hero_cta";
  if (link.closest(".tier-luxury.select")) return "tier_select";
  if (link.closest(".tier-luxury.premium")) return "tier_premium";
  return "other";
}

posthog.init("phc_2BfVw2A1jLVXE7VMC4d2obcMR7Qj7JB1d9WuYHw2ZFI", {
  api_host: "https://us.i.posthog.com",
  person_profiles: "identified_only",
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
  persistence: "localStorage+cookie",
  cross_subdomain_cookie: true,
  loaded: function (ph) {
    var params = new URLSearchParams(window.location.search);
    var props = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id"].forEach(function (k) {
      var v = params.get(k);
      if (v) props[k] = v;
    });

    var gclid = params.get("gclid");
    if (gclid) {
      props.has_gclid = true;
      props.gclid = gclid;
    }

    var fbclid = params.get("fbclid");
    if (fbclid) props.fbclid = fbclid;

    var gadCampaignId = params.get("gad_campaignid");
    if (gadCampaignId) props.gad_campaign_id = gadCampaignId;

    var gadSource = params.get("gad_source");
    if (gadSource) props.gad_source = gadSource;

    var ref = document.referrer ? new URL(document.referrer).hostname : "";
    var utmSource = props.utm_source || "";
    var utmMedium = props.utm_medium || "";
    var channel = "Direct";

    if (gclid) channel = "Google Ads";
    else if (utmSource.toLowerCase() === "klaviyo" && utmMedium === "email") channel = "Email (Klaviyo)";
    else if (utmSource.toLowerCase() === "klaviyo" && utmMedium === "sms") channel = "SMS (Klaviyo)";
    else if (utmMedium === "email") channel = "Email";
    else if (utmMedium === "paid-social" || utmMedium === "cpc") channel = "Paid Social";
    else if (utmSource === "facebook" || utmSource === "meta" || ref.indexOf("facebook.com") > -1 || ref.indexOf("l.facebook.com") > -1 || ref.indexOf("m.facebook.com") > -1) channel = "Social (Facebook)";
    else if (utmSource === "instagram" || utmSource === "meta" || ref.indexOf("instagram.com") > -1 || ref.indexOf("l.instagram.com") > -1) channel = "Social (Instagram)";
    else if (utmSource === "tiktok" || ref.indexOf("tiktok.com") > -1) channel = "Social (TikTok)";
    else if (utmMedium === "product_sync") channel = "Google Shopping (Free)";
    else if (ref.indexOf("google.") > -1 || ref === "com.google.android.googlequicksearchbox") channel = "Google Organic";
    else if (ref.indexOf("bing.com") > -1) channel = "Bing Organic";
    else if (ref.indexOf("duckduckgo") > -1 || ref.indexOf("yahoo.") > -1 || ref.indexOf("brave.com") > -1) channel = "Other Search";
    else if (ref.indexOf("youtube.com") > -1) channel = "YouTube";
    else if (ref.indexOf("yelp.com") > -1) channel = "Yelp";
    else if (utmSource === "affiliate") channel = "Affiliate";
    else if (utmSource === "shop_app") channel = "Shopify Shop App";
    else if (utmSource === "chatgpt.com" || ref.indexOf("chatgpt.com") > -1 || ref.indexOf("gemini.google.com") > -1) channel = "AI Referral";
    else if (ref && ref !== "themeatery.com" && ref !== "www.themeatery.com") channel = "Referral (" + ref + ")";
    else if (ref === "themeatery.com" || ref === "www.themeatery.com") channel = "Internal Navigation";

    props.traffic_channel = channel;
    if (Object.keys(props).length > 1 || !sessionStorage.getItem("_ph_traffic")) {
      sessionStorage.setItem("_ph_traffic", JSON.stringify(props));
    }

    var stored = JSON.parse(sessionStorage.getItem("_ph_traffic") || "{}");
    var merged = Object.assign({}, stored, props);
    ph.register(merged);

    if (merged.utm_source || merged.traffic_channel !== "Internal Navigation") {
      ph.people.set({
        last_traffic_channel: merged.traffic_channel,
        last_utm_source: merged.utm_source || "",
        last_utm_medium: merged.utm_medium || "",
        last_gad_campaign_id: merged.gad_campaign_id || "",
        last_gclid: merged.gclid || '',
        last_fbclid: merged.fbclid || '',
      });
    }
  },
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    var link = e.target.closest("a[href]");
    if (!link) return;

    var href = link.getAttribute("href");
    if (!href) return;

    if (href.indexOf("/products/") > -1) {
      var tier = inferTier(link);
      var ctaLocation = inferCtaLocation(link);
      var tp = getTrafficProps();
      var clickProps = Object.assign({}, tp, {
        cta_text: (link.textContent || "").trim().substring(0, 100),
        cta_href: href,
        subscription_tier: tier,
        cta_location: ctaLocation,
        source_page: window.location.pathname,
      });
      posthog.capture("halal_lp_cta_click", clickProps);

      var currentParams = new URLSearchParams(window.location.search);
      var productUrl = new URL(href, window.location.origin);
      ["gclid", "fbclid", "gbraid", "wbraid", "msclkid", "ttclid", "twclid", "li_fat_id", "gad_source", "gad_campaignid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id"].forEach(function (k) {
        var v = currentParams.get(k);
        if (v && !productUrl.searchParams.has(k)) productUrl.searchParams.set(k, v);
      });
      link.setAttribute("href", productUrl.toString());
    }

    if (href.indexOf("#") === 0) {
      posthog.capture(
        "halal_lp_section_click",
        Object.assign({}, getTrafficProps(), {
          section: href,
          cta_text: (link.textContent || "").trim().substring(0, 100),
        })
      );
    }
  });
});

(function () {
  var depths = [25, 50, 75, 90];
  var fired = {};
  window.addEventListener("scroll", function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = Math.round((scrollTop / docHeight) * 100);
    depths.forEach(function (d) {
      if (pct >= d && !fired[d]) {
        fired[d] = true;
        posthog.capture("halal_lp_scroll_depth", Object.assign({}, getTrafficProps(), { depth_pct: d }));
      }
    });
  });
})();

(function () {
  [30, 60, 120, 300].forEach(function (t) {
    setTimeout(function () {
      posthog.capture("halal_lp_time_on_page", Object.assign({}, getTrafficProps(), { seconds: t }));
    }, t * 1000);
  });
})();

var gs = document.createElement("script");
gs.async = true;
gs.src = "https://www.googletagmanager.com/gtag/js?id=AW-454780952";
document.head.appendChild(gs);
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "AW-454780952");
gtag("config", "G-5RXR7B3WM8");

!(function (f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () {
    if (n.callMethod) n.callMethod.apply(n, arguments);
    else n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
fbq("init", "2066716106802553");
fbq("track", "PageView");
